import { Directive, ElementRef, forwardRef, HostListener, OnDestroy, Renderer2 } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
export const VOUCHER_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => BpVoucherValueAccessor),
	multi: true
};

@Directive({
	selector: "[bpVoucher]",
	providers: [VOUCHER_VALUE_ACCESSOR],
	standalone: false
})
export class BpVoucherValueAccessor implements ControlValueAccessor, OnDestroy {
	private unlistenValue: Function;

	public constructor(
		private _renderer: Renderer2,
		private _elementRef: ElementRef
	) {
		this.unlistenValue = _renderer.listen(this._elementRef.nativeElement, "input", (x) => {
			if (x.inputType !== "deleteContentBackward") {
				this.writeValue(x.target.value);
			}
		});
	}

	public writeValue(value: any): void {
		if (!value) {
			this._renderer.setProperty(this._elementRef.nativeElement, "value", null);
			return;
		}
		this._renderer.setProperty(this._elementRef.nativeElement, "value", this.transfrom(value));
	}

	public setDisabledState?(isDisabled: boolean): void {
		this._renderer.setProperty(this._elementRef.nativeElement, "disabled", isDisabled);
	}

	@HostListener("input", ["$event.target.value"]) public onChange = (_: any): void => {
		// Empty
	};
	@HostListener("blur", []) public onTouched = (): void => {
		// Empty
	};

	public registerOnChange(fn: (_: any) => void): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	private transfrom(value: string): string {
		const s = value.replace(/[^2-9]/g, "");
		const chars = [];
		for (let i = 0; i < Math.min(s.length, 15); i += 4) {
			chars.push(s.substr(i, 4));
		}
		let code = chars.join("-");

		if (s.length % 4 === 0 && code.length !== 0 && s.length < 15) {
			code += "-";
		}

		return code.slice(0, 19);
	}

	public ngOnDestroy(): void {
		if (this.unlistenValue) {
			this.unlistenValue();
		}
	}
}
